import { render, staticRenderFns } from "./PostulacionNacionalAsignacion.vue?vue&type=template&id=e5863d38"
import script from "./PostulacionNacionalAsignacion.vue?vue&type=script&lang=js"
export * from "./PostulacionNacionalAsignacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports